module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/png@2x/chart_stock_volume_open_high_low_close@2x-143f27.png";